/**
 * The rotator function
 */
(function($) {
    $.fn.c24Rotator = function() {
        const element = $(this);
        //interval between items (in milliseconds)
        const itemInterval = 6000;
        //cross-fade time (in milliseconds)
        const fadeTime = 2500;
        //count number of items
        const numberOfItems = element.length;
        //set current item
        let currentItem = 0;
        //hide all elements
        element.hide();
        //show first item
        element.eq(currentItem).show();
        // fade function
        const fadeFunc = function() {
            element.eq(currentItem).stop().fadeOut(fadeTime);
            if (currentItem == numberOfItems - 1) { currentItem = 0; }
            else { currentItem++; }
            element.eq(currentItem).stop().fadeIn(fadeTime, function() {
                setTimeout(fadeFunc, itemInterval);
            });
        };
        //loop through the items
        setTimeout(fadeFunc, itemInterval);
    };
})(jQuery);
